import ActiveOrders from "../../../Components/Admin/ActiveOrders";
const ActiveOrdersPage = () => {
  return <ActiveOrders />;
};

export default ActiveOrdersPage;
